module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-ttl",
    attrs: {
      "id": "toc"
    }
  }, [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("___________________")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/intro"
    }
  }, [_vm._v("Introduction by Salar Abdoh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part1"
    }
  }, [_vm._v("PART I: THE CRIME PAGES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap1"
    }
  }, [_vm._v("The Fat, Fat Story of the Fat City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANIAL")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGHIGHI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Mowlavi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/chap2"
    }
  }, [_vm._v("Fear Is the Best Keeper of Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALI")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HALILI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Rey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Woman's Geography Is Sacred")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILY")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARHADPOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("University of Tehran")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II: WHEN A WAR'S NOT OVER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shelf Life of Revenge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMA")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AEEDI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Karim-Khan, Villa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Corpse Fixer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AJED")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EISI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Shahrak-e-Gharb")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lariyan's Day in the Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IDA")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORADI")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HANI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Qeytarieh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Whitest Set of Teeth in Tehran")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALAR")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BDOH")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Karim-Khan, Kuche Aban")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III: PROPER BURIAL")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Restlessness of a Serial Killer at the Finish Line")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVAD")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FHAMI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Shush")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Own Marble Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHSA")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHEBALI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Dibaji")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the Flophouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARHAAD")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EIDARI")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OORAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Gomrok")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Stoning Before Breakfast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ZARDOKHT")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHRAMI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Salehabad")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV: THE EXECUTIONER'S SONG")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bridge of Simon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OURIK")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARIM-")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASIHI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Narmak")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Not Every Bullet is Meant for a King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSSEIN")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BKENAR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Shapur")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Groom's Return")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAK")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHERI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Behesht e Zahra Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Gravedigger's Kaddish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INA")]), _vm._v(" B. N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AHAI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('i', [_vm._v("Tehrangeles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Persian Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/extra",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bonus Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/twilight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt from "), _c('i', [_vm._v("Tehran at Twilight")]), _vm._v(" by Salar Abdoh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/noir",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also in Akashic Noir Series")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/award",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Akashic Noir Series Awards & Recognition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/akb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About Akashic Books")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyrights & Credits")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b098e46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 63
// module chunks = 0